module.exports = __webpack_public_path__ + "static/media/celine.27a15e18.jpg";